import { render, staticRenderFns } from "./GrcDialog.vue?vue&type=template&id=13720662&"
import script from "./GrcDialog.vue?vue&type=script&lang=js&"
export * from "./GrcDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports